import { Component, OnInit, Input, Output } from '@angular/core';
import { Global } from '../../global';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})

export class NavMenuComponent implements OnInit {

  permissoes: any = [];
  nomeMenu: string = '';
  atividade: boolean = false;

  constructor(
    public global: Global,
  ) {
    if (JSON.parse(localStorage.getItem("currentUser")).permissoes != null) {
      this.permissoes = JSON.parse(localStorage.getItem("currentUser")).permissoes;
    }
    else {
      this.permissoes.push(
        {
          "nome": "Meus dados",
          "url": "/meus-dados",
          "sub_menus": []
        },
        {
          "nome": "Solicita Troca de Escala",
          "url": "/solicitar-troca",
          "sub_menus": []
        }, {
          "nome": "Aprova Troca de Escala",
          "url": "/aprovar-troca",
          "sub_menus": []
        }, {
          "nome": "Espelho de ponto",
          "url": "/espelho-ponto",
          "sub_menus": []
        },
        {
          "nome": "Justificar alteração de escala",
          "url": "/alteracao-escala",
          "sub_menus": []
        },
        {
          "nome": "Consultar pontos",
          "url": "/consulta-ponto",
          "sub_menus": []
        },
        {
          "nome": "Realizar ponto",
          "url": "/realizar-ponto",
          "sub_menus": []
        }
      );
    }
  }

  ngOnInit() {
  }

  abrirMenu(menuNome) {
    if (this.nomeMenu == menuNome)
      this.nomeMenu = '';
    else
      this.nomeMenu = menuNome;
  }


  feedback(clickMenu) {
    this.atividade = !this.atividade;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/nav-menu/nav-menu.component.ts